/**
 * WordPress dependencies
 */
import { Spinner } from '@wordpress/components';

export default function CanvasSpinner() {
	return (
		<div className="edit-site-canvas-spinner">
			<Spinner />
		</div>
	);
}
